<template>
	<div class="flex_1 margin_horizontal">
		<ReceivableTableWithFilter></ReceivableTableWithFilter>
	</div>
</template>
<script>
import ReceivableTableWithFilter from "@/components/templates/seller/receivables/ReceivableTableWithFilter";

export default {
	components: { ReceivableTableWithFilter },
	data() {
		return {};
	}
}
</script>